import React from 'react';

import styles from '../project.page.module.scss';

/**
 * The bar at the top of a project route: title on the left, actions on the right (the rule is
 * `justify-content: space-between`, so two children is all it takes).
 *
 * Lives here rather than in `project.page.tsx` — which still re-exports it for its existing
 * callers — because that module pulls in the entire project page graph (every route, the
 * overview screen, the entity barrel). A route that wants nothing but this 3-line component
 * should not have to import all of it, and `project-calendar.route.tsx` had a comment about a
 * circular-import ordering hazard that came from exactly that.
 */
export const Header = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['header']} ${className}` : styles['header']} {...props} />
);
